import Title from "./Title";
import Text from "./Text";
import Panel, {PanelTitle, PanelSection, PanelContainer, PanelSectionTicket} from "./Panel";
import Button from "./Button";
import ButtonExcelMultipleTable from "./ButtonExcelMultipleTable";
import ButtonExcel from "./ButtonExcel";
import FormsField, {CheckBoxGroup, FieldRecaptcha, FieldCheckPassowd} from "./FormsField";
import Heading from "./Heading";
import Spacing from "./Spacing";
import Card from "./Card";
import Icon from "./Icon";
import {InlineRow, InlineCol} from "./InlineRow";
import DetailClient from "./DetailClient";
import RenderContent from "./RenderContent";

export const CGE = {
  Title,
  Text,
  Panel,
  PanelSection,
  PanelTitle,
  PanelContainer,
  PanelSectionTicket,
  Button,
  FormsField,
  CheckBoxGroup,
  FieldRecaptcha,
  Heading,
  Spacing,
  Card,
  Icon,
  InlineRow,
  InlineCol,
  ButtonExcel,
  ButtonExcelMultipleTable,
  DetailClient,
  FieldCheckPassowd,
  RenderContent
};
